/**
 * Splits documents into the sidebar groups: Thoughts (newest first, undated
 * last) and Documents (by name).
 * @param {{ path: string, isThought: boolean, title: string, date: string }[]} docs
 */
export function groupDocs<T extends { path: string; isThought: boolean; date: string }>(
  docs: T[],
): { id: string; label: string; items: T[] }[] {
  const byName = (a: T, b: T) => a.path.localeCompare(b.path, undefined, { sensitivity: "base" });
  const thoughts = docs
    .filter((d) => d.isThought)
    .sort((a, b) => {
      if (a.date && b.date && a.date !== b.date) return a.date < b.date ? 1 : -1;
      if (a.date && !b.date) return -1;
      if (!a.date && b.date) return 1;
      return byName(a, b);
    });
  const documents = docs.filter((d) => !d.isThought).sort(byName);
  return [
    { id: "thoughts", label: "Thoughts", items: thoughts },
    { id: "documents", label: "Documents", items: documents },
  ].filter((g) => g.items.length > 0);
}
